export const CUSTOMER_ADDRESS_EMAIL_TEMPLATE = (formData) => `
<!DOCTYPE html>
<html>

<head>
  <meta charset="UTF-8" />
  <title>fixINN Email</title>
  <link href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400&display=swap" rel="stylesheet" />
  <style>
    body {
      margin: 0;
      padding: 0;
      background-color: #f5f5f5;
      font-family: 'Sora', sans-serif;
    }

   @media only screen and (max-width: 550px) {
      .container {
        width: 100% !important;
      }

      .two-column {
        display: block !important;
        width: 100% !important;
      }

      .two-column td {
        display: block !important;
        width: 100% !important;
      }

      .two-column td table {
        width: 100% !important;
      }

      .two-column td table tr {
        display: flex;
      }

      .two-column td table tr td {
        width: auto !important;
      }

      .footer-contact {
        flex-direction: column !important;
        gap: 10px !important;
        padding: 10px !important;
      }

      .footer-contact>div {
        justify-content: center !important;
      }

      .footer-text {
        font-size: 14px !important;
      }
    }
  </style>
</head>

<body>
  <table width="100%" cellpadding="0" cellspacing="0" style="padding: 20px 0;">
    <tr>
      <td align="center">
        <!-- Main Content Container -->
        <table cellpadding="0" cellspacing="0" width="600" class="container"
          style="max-width: 600px; background: #ffffff; border-radius: 10px 10px 0 0;">
          <tr>
            <td align="center" style="padding: 30px 20px 10px;">
              <img src="https://fixinn.netlify.app/logo512.png" width="100" height="100" alt="Logo"
                style="margin-bottom: 10px;" />
              <h2 style="font-weight: 400; font-size: 20px; color: #000000; margin: 0;">Hi <span
                  style="color: #B30F29;">${formData.fullName}</span>,</h2>
              <p style="font-weight: 300; font-size: 16px; color: #333333; margin-top: 10px;">Thanks for choosing
                fixINN for your device repair needs. We’ve received your request and our team will get in touch
                shortly.</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 20px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <!-- 1st Row -->
                <tr class="two-column">
                  <td width="50%" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/serviceType.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Service Type</div>
                          <div style="font-size: 14px;">${formData.service}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="50%" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/deviceType.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Device Type</div>
                          <div style="font-size: 14px;">${formData.deviceType}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- 2nd Row -->
                <tr class="two-column">
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/brand.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Brand & Model</div>
                          <div style="font-size: 14px;">${formData.deviceName}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/pickupAddress.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Pickup Address</div>
                          <div style="font-size: 14px;">${formData.pickupAddress}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- 3rd Row -->
                <tr class="two-column">
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/date.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Preferred Pickup Date</div>
                          <div style="font-size: 14px;">${formData.pickupDate}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/time.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Preferred Pickup Time</div>
                          <div style="font-size: 14px;">${formData.pickupTime}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- Description -->
                <tr>
                  <td colspan="2" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/description.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Issue Description</div>
                          <div style="font-size: 14px;">${formData.issueDescription}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <p style="margin-top: 20px; font-size: 16px; font-weight: 400; color: #333333; text-align: center">
                We'll contact you soon to confirm your booking and next steps.<br />
                Need help? Email us at
                <a href="mailto:support@fixinn.co.uk" style="color: #B30F29;">support@fixinn.co.uk</a>
              </p>
            </td>
          </tr>
        </table>

        <!-- Footer Section -->
        <table cellpadding="0" cellspacing="0" width="100%" style="width: 100%; max-width: 100%;" class="container">
          <tr>
            <td style="padding: 0; margin: 0;">
              <div style="
                background-image:
                  linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
                  url('https://fixinn.netlify.app/girl_image.png'),
                  url('https://fixinn.netlify.app/background.png');
                  background-size: cover, contain, cover;
                  background-position: center bottom;
                  background-repeat: no-repeat;
                  height: 641px;
                  width: 100%;
                  text-align: center;
                  font-family: 'Sora', sans-serif;
                  color: #ffffff;
                  position: relative;
                  display: block;
                  padding-bottom: 40px;
              ">

                <table cellpadding="0" cellspacing="0" border="0" width="100%" height="100%" style="height: 100%;">
                  <tr>
                    <td valign="bottom" style="padding: 0; margin: 0;">
                      <div style="position: absolute; bottom: 0; left: 0;width: 100%; height: auto;">
                        <p style="margin: 10px 0;">
                          <a href="#"><img src="https://fixinn.netlify.app/facebook.png" width="20"
                              style="margin: 0 5px;" /></a>
                          <a href="#"><img src="https://fixinn.netlify.app/instagram.png" width="20"
                              style="margin: 0 5px;" /></a>
                          <a href="#"><img src="https://fixinn.netlify.app/twitter.png" width="20"
                              style="margin: 0 5px;" /></a>
                        </p>

                        <!-- Footer Text -->
                        <p style="margin: 0;">Copyright &copy; 2025</p>
                        <p style="margin: 0;">Fixinn</p>
                        <p style="margin: 0;">Expert Repairs. Reliable Service. Every Time.</p>

                        <!-- Contact Info -->
                        <table align="center" cellpadding="0" cellspacing="0" role="presentation"
                          style="margin: 20px auto;">
                          <tr>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/phone.png" width="20"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="tel:07946203616"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">07946203616</a>
                            </td>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/mail.png" width="20"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="mailto:contact@fixinn.co.uk"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">contact@fixinn.co.uk</a>
                            </td>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/globe.png" width="22"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="https://www.fixinn.co.uk"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">www.fixinn.co.uk</a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>

</html>
`;

export const CUSTOMER_WITHOUT_ADDRESS_EMAIL_TEMPLATE = (formData) => `
<!DOCTYPE html>
<html>

<head>
  <meta charset="UTF-8" />
  <title>fixINN Email</title>
  <link href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400&display=swap" rel="stylesheet" />
  <style>
    body {
      margin: 0;
      padding: 0;
      background-color: #f5f5f5;
      font-family: 'Sora', sans-serif;
    }

   @media only screen and (max-width: 550px) {
      .container {
        width: 100% !important;
      }

      .two-column {
        display: block !important;
        width: 100% !important;
      }

      .two-column td {
        display: block !important;
        width: 100% !important;
      }

      .two-column td table {
        width: 100% !important;
      }

      .two-column td table tr {
        display: flex;
      }

      .two-column td table tr td {
        width: auto !important;
      }

      .footer-contact {
        flex-direction: column !important;
        gap: 10px !important;
        padding: 10px !important;
      }

      .footer-contact>div {
        justify-content: center !important;
      }

      .footer-text {
        font-size: 14px !important;
      }
    }
  </style>
</head>

<body>
  <table width="100%" cellpadding="0" cellspacing="0" style="padding: 20px 0;">
    <tr>
      <td align="center">
        <!-- Main Content Container -->
        <table cellpadding="0" cellspacing="0" width="600" class="container"
          style="max-width: 600px; background: #ffffff; border-radius: 10px 10px 0 0;">
          <tr>
            <td align="center" style="padding: 30px 20px 10px;">
              <img src="https://fixinn.netlify.app/logo512.png" width="100" height="100" alt="Logo"
                style="margin-bottom: 10px;" />
              <h2 style="font-weight: 400; font-size: 20px; color: #000000; margin: 0;">Hi <span
                  style="color: #B30F29;">${formData.fullName}</span>,</h2>
              <p style="font-weight: 300; font-size: 16px; color: #333333; margin-top: 10px;">Thanks for choosing
                fixINN for your device repair needs. We’ve received your request and our team will get in touch
                shortly.</p>
            </td>
          </tr>
          <tr>
            <td style="padding: 20px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <!-- 1st Row -->
                <tr class="two-column">
                  <td width="50%" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/serviceType.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Service Type</div>
                          <div style="font-size: 14px;">${formData.service}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="50%" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/deviceType.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Device Type</div>
                          <div style="font-size: 14px;">${formData.deviceType}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- 2nd Row -->
                <tr class="two-column">
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/brand.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Brand & Model</div>
                          <div style="font-size: 14px;">${formData.deviceName}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- 3rd Row -->
                <tr class="two-column">
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/date.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Preferred Pickup Date</div>
                          <div style="font-size: 14px;">${formData.pickupDate}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/time.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Preferred Pickup Time</div>
                          <div style="font-size: 14px;">${formData.pickupTime}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>

                <!-- Description -->
                <tr>
                  <td colspan="2" style="padding: 10px;">
                    <table>
                      <tr>
                        <td><img src="https://fixinn.netlify.app/description.png" width="34" height="34" /></td>
                        <td style="padding-left: 10px;">
                          <div style="font-size: 12px; color: #00000099;">Issue Description</div>
                          <div style="font-size: 14px;">${formData.issueDescription}</div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <p style="margin-top: 20px; font-size: 16px; font-weight: 400; color: #333333; text-align: center">
                We'll contact you soon to confirm your booking and next steps.<br />
                Need help? Email us at
                <a href="mailto:support@fixinn.co.uk" style="color: #B30F29;">support@fixinn.co.uk</a>
              </p>
            </td>
          </tr>
        </table>

        <!-- Footer Section -->
        <table cellpadding="0" cellspacing="0" width="100%" style="width: 100%; max-width: 100%;" class="container">
          <tr>
            <td style="padding: 0; margin: 0;">
              <div style="
                background-image:
                  linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
                  url('https://fixinn.netlify.app/girl_image.png'),
                  url('https://fixinn.netlify.app/background.png');
                  background-size: cover, contain, cover;
                  background-position: center bottom;
                  background-repeat: no-repeat;
                  height: 641px;
                  width: 100%;
                  text-align: center;
                  font-family: 'Sora', sans-serif;
                  color: #ffffff;
                  position: relative;
                  display: block;
                  padding-bottom: 40px;
              ">

                <table cellpadding="0" cellspacing="0" border="0" width="100%" height="100%" style="height: 100%;">
                  <tr>
                    <td valign="bottom" style="padding: 0; margin: 0;">
                      <div style="position: absolute; bottom: 0; left: 0;width: 100%; height: auto;">
                        <p style="margin: 10px 0;">
                          <a href="#"><img src="https://fixinn.netlify.app/facebook.png" width="20"
                              style="margin: 0 5px;" /></a>
                          <a href="#"><img src="https://fixinn.netlify.app/instagram.png" width="20"
                              style="margin: 0 5px;" /></a>
                          <a href="#"><img src="https://fixinn.netlify.app/twitter.png" width="20"
                              style="margin: 0 5px;" /></a>
                        </p>

                        <!-- Footer Text -->
                        <p style="margin: 0;">Copyright &copy; 2025</p>
                        <p style="margin: 0;">Fixinn</p>
                        <p style="margin: 0;">Expert Repairs. Reliable Service. Every Time.</p>

                        <!-- Contact Info -->
                        <table align="center" cellpadding="0" cellspacing="0" role="presentation"
                          style="margin: 20px auto;">
                          <tr>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/phone.png" width="20"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="tel:07946203616"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">07946203616</a>
                            </td>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/mail.png" width="20"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="mailto:contact@fixinn.co.uk"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">contact@fixinn.co.uk</a>
                            </td>
                            <td align="center" style="padding: 0 10px;">
                              <img src="https://fixinn.netlify.app/globe.png" width="22"
                                style="vertical-align: middle; margin-right: 5px;" />
                              <a href="https://www.fixinn.co.uk"
                                style="color: #ffffff; text-decoration: none; font-family: sans-serif;">www.fixinn.co.uk</a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>

</html>
`;


export const CUSTOMER_ADMIN_EMAIL_TEMPLATE = (formData) => `
<!DOCTYPE html>
<html>

<head>
    <meta charset="UTF-8" />
    <title>fixINN Email</title>
    <link href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400&display=swap" rel="stylesheet" />
    <style>
        body {
            margin: 0;
            padding: 0;
            background-color: #f5f5f5;
            font-family: 'Sora', sans-serif;
        }

        @media only screen and (max-width: 550px) {
            .container {
                width: 100% !important;
            }

            .two-column {
                display: block !important;
                width: 100% !important;
            }

            .two-column td {
                display: block !important;
                width: 100% !important;
            }

            .two-column td table {
                width: 100% !important;
            }

            .two-column td table tr {
                display: flex;
            }

            .two-column td table tr td {
                width: auto !important;
            }

            .footer-contact {
                flex-direction: column !important;
                gap: 10px !important;
                padding: 10px !important;
            }

            .footer-contact>div {
                justify-content: center !important;
            }

            .footer-text {
                font-size: 14px !important;
            }
        }
    </style>
</head>

<body>
    <table width="100%" cellpadding="0" cellspacing="0" style="padding: 20px 0;">
        <tr>
            <td align="center">
                <!-- Main Content Container -->
                <table cellpadding="0" cellspacing="0" width="600" class="container"
                    style="max-width: 600px; background: #ffffff; border-radius: 10px 10px 0 0;">
                    <tr>
                        <td align="center" style="padding: 30px 20px 10px;">
                            <img src="https://fixinn.netlify.app/logo512.png" width="100" height="100" alt="Logo"
                                style="margin-bottom: 10px;" />
                            <h2 style="font-weight: 400; font-size: 20px; color: #000000; margin: 0;">Hi <span
                                    style="color: #B30F29;">Admin</span>,</h2>
                            <p style="font-weight: 300; font-size: 16px; color: #333333; margin-top: 10px;">A new
                                service form has been submitted on the website. Here are the details:</p>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 20px;">
                            <table width="100%" cellpadding="0" cellspacing="0">
                                <!-- 1st Row -->
                                <tr class="two-column">
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/person.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Customer Name</div>
                                                    <div style="font-size: 14px;">${formData.fullName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/email.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Customer Email</div>
                                                    <div style="font-size: 14px;">${formData.email}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr class="two-column">
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/phone-p.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Phone</div>
                                                    <div style="font-size: 14px;">${formData.phone}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/deviceType.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Device Type</div>
                                                    <div style="font-size: 14px;">${formData.deviceType}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <tr class="two-column">
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/serviceType.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Service Type</div>
                                                    <div style="font-size: 14px;">${formData.type}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td width="50%" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/brand.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Brand & Model</div>
                                                    <div style="font-size: 14px;">${formData.deviceName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <!-- Description -->
                                <tr>
                                    <td colspan="2" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/pickupAddress.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Pickup Address
                                                    </div>
                                                    <div style="font-size: 14px;">${formData.pickupAddress}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <!-- 3rd Row -->
                                <tr class="two-column">
                                    <td style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/date.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Preferred Pickup
                                                        Date</div>
                                                    <div style="font-size: 14px;">${formData.pickupDate}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/time.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Preferred Pickup
                                                        Time</div>
                                                    <div style="font-size: 14px;">${formData.pickupTime}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>

                                <!-- Description -->
                                <tr>
                                    <td colspan="2" style="padding: 10px;">
                                        <table>
                                            <tr>
                                                <td><img src="https://fixinn.netlify.app/description.png" width="34"
                                                        height="34" /></td>
                                                <td style="padding-left: 10px;">
                                                    <div style="font-size: 12px; color: #00000099;">Issue Description
                                                    </div>
                                                    <div style="font-size: 14px;">${formData.issueDescription}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>

                            <p
                                style="margin-top: 20px; font-size: 16px; font-weight: 400; color: #333333; text-align: center">
                                Please follow up with the customer as soon as possible.
                            </p>
                        </td>
                    </tr>

                    <!-- Footer Section -->
                    <table cellpadding="0" cellspacing="0" width="600px" class="container">
                        <tr>
                            <td style="padding: 0; margin: 0;">
                                <div style="
                    background: #ffffff;
                  height: 100px;
                  width: auto;
                  text-align: center;
                  font-family: 'Sora', sans-serif;
                  color: black;
                  position: relative;
                  margin-bottom: 10px;
                  display: block;
              ">

                                    <table cellpadding="0" cellspacing="0" border="0" width="100%" height="100%"
                                        style="height: 100%;">
                                        <tr>
                                            <td valign="bottom" style="padding: 0; margin: 0;">
                                                <div
                                                    style="position: absolute; bottom: 0; left: 0;width: 100%; height: auto;">
                                                    <p style="margin: 10px 0;">
                                                        <a href="#"><img src="https://fixinn.netlify.app/facebook-p.png"
                                                                width="20" style="margin: 0 5px;" /></a>
                                                        <a href="#"><img src="https://fixinn.netlify.app/insta-p.png"
                                                                width="20" style="margin: 0 5px;" /></a>
                                                        <a href="#"><img src="https://fixinn.netlify.app/x-p.png"
                                                                width="20" style="margin: 0 5px;" /></a>
                                                    </p>

                                                    <!-- Footer Text -->
                                                    <p style="margin: 0;">Copyright &copy; 2025</p>
                                                    <p style="margin: 0;">fixINN</p>
                                                    <p style="margin: 0;">Expert Repairs. Reliable Service. Every Time.
                                                    </p>

                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </table>

                </table>
            </td>
        </tr>
    </table>
</body>

</html>
`